const state = {
  isNew: true,
  isLoading: false, // USED TO SHOW PROGRESS BAR ON CREATION PAGE
  name: "", // CONTAINS PROJECT NAME
  openData: {}, // OBJECT FOR CREATION PAGE : { projId: 0, projectName: "", savePath: "" }
  properties: {
    width: 0,
    height: 0,
    scale: { x: 1, y: 1 },
  }, // OBJECT FOR KONVA : { x: 0, y: 0, width: 0, height: 0, scale: { x: 1, y: 1} }
};

const mutations = {
  LOADSTARTED: function (state) {
    state.isLoading = true;
  },
  LOADFINISHED: function (state) {
    state.isLoading = false;
  },
  NEW: function (state, datas) {
    state.isNew = true;
    state.name = datas.name;
    state.properties = datas.properties;
  },
  OPEN: function (state, data) {
    state.isNew = false;
    state.openData = data;
  },
  SETSIZE: function (state, data) {
    state.properties.width = data.width;
    state.properties.height = data.height;
  },
};

const actions = {
  loadStarted: ({ commit }) => {
    commit("LOADSTARTED");
  },
  loadFinished: ({ commit }) => {
    commit("LOADFINISHED");
  },
  new: ({ commit }, datas) => {
    commit("NEW", datas);
  },
  open: ({ commit }, data) => {
    commit("LOADSTARTED");
    commit("OPEN", data);
  },
  setSize: ({ commit }, data) => {
    commit("SETSIZE", data);
  },
};

export default {
  state,
  mutations,
  actions,
};
